import { render, staticRenderFns } from "./backNavLastPage.vue?vue&type=template&id=297d22b3&scoped=true&"
import script from "./backNavLastPage.vue?vue&type=script&lang=js&"
export * from "./backNavLastPage.vue?vue&type=script&lang=js&"
import style0 from "./backNavLastPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./backNavLastPage.vue?vue&type=style&index=1&id=297d22b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297d22b3",
  null
  
)

export default component.exports